import { useParams } from "react-router-dom";
import useFetch from "../../../clients/features/get";
import HotelHeader from "./HotelHeader";
import HotelInfo from "./HotelInfo";
import PhotosManager from "./PhotosManager";
import EquipmentsManager from "./EquipmentsManager";
import LocationManager from "./LocationManager";
import "./HotelSettings.css";

export default function Dashboard() {
  const { hotelId } = useParams();
  const { data, loading, refreshData } = useFetch(
    `https://api.komorotel.com/api/hotels/find/${hotelId}`
  );

  // Loader seulement au premier chargement : lors d'un rafraîchissement,
  // on garde la page affichée au lieu de la faire clignoter
  if (loading && !data) return <div className="modern-loader" />;

  return (
    <div className="dashboard-container">
      <HotelHeader data={data} refreshData={refreshData} />

      {/* Bloc compact, la carte complète s'ouvre au clic */}
      <LocationManager data={data} hotelId={hotelId} refreshData={refreshData} />

      <div className="dashboard-grid">
        <HotelInfo data={data} refreshData={refreshData} />
        <PhotosManager data={data} hotelId={hotelId} refreshData={refreshData} />
      </div>

      <EquipmentsManager data={data} hotelId={hotelId} refreshData={refreshData} />
    </div>
  );
}